var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"100%","height":"100%"}},[(!_vm.isAuthenticated && !_vm.userName)?_c('UserName'):_c('Project',{attrs:{"leaveRoomIfJoined":_vm.leaveRoomIfJoined,"activeRoom":_vm.activeRoom,"setActiveRoom":_vm.setActiveRoom}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }